import { Icon as DsIcon } from "@equipmentshare/ds-icon";
import { Col as AntCol, Row as AntRow } from "antd";
import React from "react";

import * as Color from "~/Color";
import * as ErrorMessage from "~/ErrorMessage";
import * as Layout from "~/Layout";
import * as Typography from "~/Typography";

export namespace Form {
  export namespace Field {
    export type Name<F extends string> = F;

    type Props<A extends string> = Label.Props & Error<A>;

    export function Vertical<A extends string>(props: Props<A>) {
      return (
        <>
          <Label.Vertical {...props} />
          <Errors {...props} />
        </>
      );
    }

    export namespace Label {
      export type Props = {
        readonly label: string;
        readonly isRequired?: boolean;
        readonly children: React.ReactNode;
      };

      export const RequiredLabel = ({
        children,
      }: {
        readonly children?: React.ReactNode;
      }) => (
        <Typography.H4.Component>
          {children}{" "}
          <Typography.Component color={Color.guardsmanRed()}>
            *
          </Typography.Component>
        </Typography.H4.Component>
      );

      export function Vertical({ label, isRequired, children }: Props) {
        return (
          <>
            <AntRow style={{ padding: "8px" }}>
              <AntCol span={24} style={{ paddingBottom: "4px" }}>
                {isRequired ? (
                  <RequiredLabel>{label}</RequiredLabel>
                ) : (
                  <Typography.H4.Component>{label}</Typography.H4.Component>
                )}
              </AntCol>
              <AntCol span={24}>{children}</AntCol>
            </AntRow>
          </>
        );
      }
    }

    export type Error<A extends string> = {
      readonly names: readonly Name<A>[];
      readonly errors?: ValidationErrors<A>;
    };

    export function Errors<A extends string>(props: Error<A>) {
      if (props.errors) {
        return (
          <>
            {props.names.map(
              (name) =>
                props.errors &&
                props.errors[name] && (
                  <Layout.Flex.Component
                    key={`error-${name}`}
                    row
                    justify="stretch"
                    align="center"
                    all
                  >
                    <ErrorMessage.Component danger>
                      <Layout.Flex.Component
                        row
                        justify="stretch"
                        align="center"
                      >
                        <DsIcon name="$icon_error_warning_fill" />{" "}
                        {props.errors[name]}
                      </Layout.Flex.Component>
                    </ErrorMessage.Component>
                  </Layout.Flex.Component>
                )
            )}
          </>
        );
      }
      return null;
    }

    export type ValidationErrors<A extends string> = Record<
      Field.Name<A>,
      string | undefined
    >;
  }
}
